import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "position-relative" }

import {ref, watch} from "vue";
import ButtonBase from "@/components/custom/ButtonBase.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonFilterSelect',
  props: {
  modelValue: {
    type: [Object, String],
  },
  text: {
    type: String,
    default: 'Filter'
  },
  items: {
    type: Array,
    required: true,
  },
  isTabSelected: {
    type: Boolean,
    required: true,
  },
  itemTitle: {
    type: String,
    default: 'label',
  },
  itemValue: {
    type: String,
    default: 'name',
  },
  multiple: {
    type: Boolean,
    default: true
  },
  singleLine: {
    type: Boolean,
    default: false
  },
  icon: {
    type: String,
    default: 'filter-icon'
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const emit = __emit

const props = __props

const setSelect = ref(props.modelValue);

watch(() => props.modelValue, (value) => {
  setSelect.value = value;
});

watch(setSelect, (value) => {
  return emit('update:modelValue', value);
});

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ButtonBase, {
      icon: __props.icon,
      "color-icon": __props.isTabSelected ? 'white' : null,
      "custom-class": [{'text-white': __props.isTabSelected}],
      variant: __props.isTabSelected ? 'elevated':'outlined',
      "custom-icon-class": "mr-2 text",
      text: __props.text[__props.itemTitle],
      width: "100%",
      count: setSelect.value.length,
      "active-filter": __props.isTabSelected,
      "single-line": __props.singleLine
    }, null, 8, ["icon", "color-icon", "custom-class", "variant", "text", "count", "active-filter", "single-line"]),
    _createVNode(_component_v_select, {
      class: "select-dropdown",
      variant: "underlined",
      "item-title": __props.itemTitle,
      "item-value": __props.itemValue,
      modelValue: setSelect.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((setSelect).value = $event)),
      items: __props.items,
      multiple: __props.multiple,
      "single-line": __props.singleLine,
      "return-object": "",
      "menu-icon": "''"
    }, {
      selection: _withCtx(() => [
        _renderSlot(_ctx.$slots, "selection")
      ]),
      _: 3
    }, 8, ["item-title", "item-value", "modelValue", "items", "multiple", "single-line"])
  ]))
}
}

})